import Link from "next/link";
import ResourcesHeader from "../Resources/shared/ResourcesHeader";
import Expand from "elements/ExpandButton";
import { CSSProperties } from "react";
import { ContentfulEntryType } from "utils/types";
import { useResponsiveContext } from "context/ResponsiveContext";

export default function ResourceCard({
	type,
	href,
	id,
	img,
	date,
	title,
	description,
	savings,
	style,
	variant = "vertical",
	size = "default",
	tags,
}: {
	type: ContentfulEntryType;
	href: string;
	id: string;
	img: string;
	date: string;
	title: string;
	description: string;
	savings: string;
	style?: CSSProperties;
	variant?: "vertical" | "horizontal" | "featured";
	size?: "default" | "large";
	tags?: string[];
}) {
	const { isMobile } = useResponsiveContext();

	return (
		<div className={`resource-card ${variant} ${size}`} style={style}>
			<Link passHref key={id} href={href}>
				<div
					className="resource-card-img"
					style={{ backgroundImage: `url(${img})` }}></div>
				<div className="resource-card-bg">
					<div
						className={
							"card-header-wrapper" + (variant != "horizontal" ? " pt-2" : "")
						}>
						<ResourcesHeader date={date} />
						<p className="resource-card-savings extra-small">
							{type === "casestudy" ? `${savings} Saved` : ""}
						</p>
					</div>
					<p className="resource-card-title large bold hover-title">{title}</p>
					<p className="resource-card-description small denim-medium">
						{description}
					</p>
					<div
						className={
							"resource-card-footer" + (variant != "horizontal" ? " mt-1" : "")
						}>
						{(variant != "horizontal" || isMobile) && (
							<div className="resource-card-tags-container">
								{tags
									?.filter(
										tag =>
											tag.toLowerCase() === "residential" ||
											tag.toLowerCase() === "commercial"
									)
									.map(tag => (
										<p
											key={tag}
											className="resource-card-tag extra-small royal bold">
											{tag.charAt(0).toUpperCase() + tag.slice(1).toLowerCase()}
										</p>
									))}
							</div>
						)}
						<div className="resource-card-read-more">
							<Expand defaultActive={false} noSwitch>
								Read More
							</Expand>
						</div>
					</div>
				</div>
			</Link>
		</div>
	);
}
